import { Box, FormikTextInput } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';

import { RequirementFlagSettingsType } from 'types';

import FormSection from '../Forms/FormSection';
import { FlagBox } from '../QueueFlags/FlagBox';

export const CommunityName = ({ isPackageEditable = true }: { isPackageEditable?: boolean }) => {
  const { isSubmitting } = useFormikContext<any>();
  return (
    <FormSection title="Community Name">
      <FlagBox dataKey="Community Name" flagType={RequirementFlagSettingsType.communityName} displayWithNoQueue>
        <Box
          direction={{ base: 'column', tablet: 'row' }}
          alignItems="center"
          childGap={{ base: 'lg', tablet: '3xl' }}
          width="100"
        >
          <Field
            hideLabel
            name="communityName"
            id="communityName"
            component={FormikTextInput}
            type="text"
            isDisabled={isSubmitting || !isPackageEditable}
          />
        </Box>
      </FlagBox>
    </FormSection>
  );
};
